import { z } from 'zod';

import { type CreateCurationsServiceResponse, CurationApiTypeSchema } from './create-curations.dto';

export const CreateSnapCurationsServiceRequestSchema = z
  .object({
    title: z.string(),
    description: z.string(),
    /** OpenAPI `CreateCurationV2Request.snapIdList` */
    snapIdList: z.array(z.string()).default([]),
    curationType: CurationApiTypeSchema,
  })
  .describe('CreateSnapCurationsServiceRequestSchema');

export type CreateSnapCurationsServiceRequest = z.infer<
  typeof CreateSnapCurationsServiceRequestSchema
>;
export type CreateSnapCurationsServiceResponse = CreateCurationsServiceResponse;
